import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomTextArea,
} from '../../../common/components';

const PreAdjReasonDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({
        name: selectedItem?.name || '',
        description: selectedItem?.description || '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode
          ? `Editar Motivo de Preadjudicación: ${formData.name}`
          : 'Agregar Motivo de Preadjudicación'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
              helperText={
                errors.name || (saveAttempted && !formData.name) ? 'Debes ingresar un nombre.' : ''
              }
            />

            <CustomTextArea
              label={'Descripción'}
              margin="dense"
              name="description"
              placeholder="Descripción"
              rows={4}
              fullWidth
              value={formData.description}
              onChange={handleInputChange}
            />
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default PreAdjReasonDialog;
